
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Onlinecabbookinginpune() {



    const cardData =
    {
        keyword: 'Online Cab Booking in Pune',
        heading: 'Meghana Cab : Online Cab Booking in Pune',
        headingDescription: 'Meghana Cab offers Online Cab Booking in Pune, making your travel seamless, reliable, and convenient. Whether you are heading to the airport, planning a business trip, or exploring the city, our user-friendly online platform ensures quick and hassle-free cab reservations. Choose from a range of clean, well-maintained vehicles driven by professional chauffeurs for a safe and comfortable ride. Enjoy transparent pricing, punctual service, and 24/7 availability with Meghana Cab. Book your cab online in Pune with Meghana Cab and experience smooth travel at your fingertips!',


        top: 'Top Places to Visit in Pune with Meghana Cab',

       "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "A historic fortification in the heart of Pune, Shaniwar Wada was built in 1732 by the Peshwas of the Maratha Empire. Once the seat of the Peshwa rulers, this grand palace is known for its magnificent architecture, massive gateways, and intriguing legends. The evening light and sound show offers a captivating retelling of its history, making it a must-visit for history lovers."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892 by Sultan Muhammed Shah Aga Khan III, this stunning palace holds great historical significance. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other freedom fighters during the Indian independence movement. The palace is surrounded by lush gardens and houses a museum displaying artifacts related to Gandhi's life and legacy."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop a hill, Sinhagad Fort offers breathtaking panoramic views of the surrounding landscape. This fort, which was the site of the historic Battle of Sinhagad in 1670, is a favorite among trekking enthusiasts. Visitors can explore the ruins, pay homage to the brave warrior Tanaji Malusare, and enjoy local delicacies like pithla bhakri at nearby food stalls."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene retreat for spiritual seekers. It offers a variety of meditation programs, wellness sessions, and yoga classes in a peaceful environment. The ashram attracts visitors from across the globe looking to rejuvenate their mind and body through mindfulness and meditation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An ancient rock-cut temple dedicated to Lord Shiva, Pataleshwar Cave Temple dates back to the 8th century. Carved out of a single basalt rock, this temple features beautiful stone pillars and a sanctum with a Shiva Lingam. The tranquil atmosphere makes it an ideal spot for those seeking a blend of history, spirituality, and ancient architecture."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This unique museum houses an extensive collection of over 20,000 artifacts, including sculptures, paintings, weapons, musical instruments, and everyday household items from different periods of Indian history. It provides a fascinating insight into the artistic heritage of Maharashtra and India as a whole."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A scenic getaway just a short drive from Pune, Khadakwasla Dam is a perfect spot for nature lovers and picnickers. The dam, which supplies water to Pune, offers stunning views of the reservoir and nearby hills. The cool breeze and peaceful surroundings make it an excellent location for a leisurely evening outing."
  },
  {
    "title": "Fergusson College Road",
    "description": "Known for its vibrant and youthful energy, Fergusson College Road is a popular hangout spot among students and young travelers. It is lined with cafes, bookstores, street vendors, and shopping outlets. Whether you're looking for trendy fashion, delicious street food, or a lively atmosphere, this street has something for everyone."
  },
  {
    "title": "Lal Mahal",
    "description": "A historically significant landmark, Lal Mahal was originally built in the 1630s by Shahaji Bhosale for his son, Chhatrapati Shivaji Maharaj. Though the original structure was destroyed, the reconstructed Lal Mahal offers a glimpse into the childhood of Shivaji Maharaj and features paintings and artifacts related to his life."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Also known as the Japanese Garden, this beautifully designed landscape park is inspired by the Korakuen Garden in Okayama, Japan. It features manicured lawns, flowing streams, koi ponds, and traditional Japanese-style architecture. It's a perfect place for a peaceful stroll or a relaxing family outing."
  }
],

        "services": [
    {
        "name": "Online Taxi Booking Pune",
        "description": "Book your taxi online in Pune effortlessly with Meghana Cab. Whether it's for daily commutes or special trips, our seamless online booking platform ensures a smooth and quick experience. Choose from a wide range of vehicles for a reliable and convenient ride."
    },
    {
        "name": "Book a Cab Online in Pune",
        "description": "Need a cab in Pune? Book online with Meghana Cab for instant confirmations and quick pickups. Our online cab booking system is designed for your convenience—ideal for daily travel, errands, or long-distance rides."
    },
    {
        "name": "24x7 Cab Booking in Pune",
        "description": "Meghana Cab offers round-the-clock cab booking services in Pune. No matter the time, you can count on our 24x7 service for a safe and dependable ride, with professional drivers and well-maintained vehicles."
    },
    {
        "name": "Quick Cab Booking Pune",
        "description": "In a hurry? Use Meghana Cab’s quick cab booking service in Pune for fast and reliable pickups. Our streamlined booking process ensures that you get on the road with minimal waiting time."
    },
    {
        "name": "Affordable Online Cabs Pune",
        "description": "Get the best value for your travel with Meghana Cab’s affordable online cab services in Pune. Competitive pricing, clean vehicles, and excellent service make us a top choice for budget-friendly rides."
    },
    {
        "name": "Pune Online Taxi App",
        "description": "Download the Meghana Cab app for seamless online taxi booking in Pune. The app provides real-time tracking, fare estimates, and multiple vehicle options to meet all your travel needs."
    },
    {
        "name": "Instant Cab Hire in Pune",
        "description": "Need a cab immediately? Meghana Cab offers instant cab hire services in Pune. With a large fleet and strategic availability, we ensure minimal wait times and maximum convenience."
    },
    {
        "name": "Book Sedan Online Pune",
        "description": "Travel in comfort by booking a sedan online with Meghana Cab in Pune. Our sedans are perfect for business travel, airport transfers, or city rides with added comfort and style."
    },
    {
        "name": "SUV Online Booking Pune",
        "description": "Planning a trip with extra luggage or more passengers? Book an SUV online in Pune with Meghana Cab. Spacious and powerful, our SUVs are ideal for city tours or outstation journeys."
    },
    {
        "name": "Pune City Cab Booking",
        "description": "Explore Pune with ease by booking a city cab with Meghana Cab. Our city taxi service is perfect for sightseeing, errands, or casual travel within the city, offering convenience and safety at every step."
    },
    {
        "name": "Outstation Cab Online Pune",
        "description": "Heading out of Pune? Book your outstation cab online with Meghana Cab for comfortable and reliable travel to nearby cities and destinations. Enjoy safe, timely, and affordable intercity travel."
    },
    {
        "name": "Easy Cab Booking Platform Pune",
        "description": "Meghana Cab offers an easy-to-use online platform for booking cabs in Pune. Just a few clicks and your ride is confirmed—perfect for busy schedules and hassle-free travel planning."
    },
    {
        "name": "Best Online Cab Deals in Pune",
        "description": "Looking for great deals on cab bookings? Meghana Cab offers the best online cab deals in Pune. Enjoy discounts, offers, and value-packed rides with top-notch service."
    },
    {
        "name": "Online AC Cab Booking Pune",
        "description": "Stay cool and comfortable with Meghana Cab’s online AC cab booking in Pune. Our air-conditioned vehicles ensure a pleasant ride, no matter the weather or distance."
    },
    {
        "name": "Local & Outstation Cabs Online Pune",
        "description": "Whether you're traveling locally or heading out of town, Meghana Cab has you covered. Book local and outstation cabs online in Pune with ease and enjoy a dependable travel experience."
    }
],

"tableData": [
    ["Online Taxi Booking Pune", "Book a Cab Online in Pune"],
    ["24x7 Cab Booking in Pune", "Quick Cab Booking Pune"],
    ["Affordable Online Cabs Pune", "Pune Online Taxi App"],
    ["Instant Cab Hire in Pune", "Book Sedan Online Pune"],
    ["SUV Online Booking Pune", "Pune City Cab Booking"],
    ["Outstation Cab Online Pune", "Easy Cab Booking Platform Pune"],
    ["Best Online Cab Deals in Pune", "Online AC Cab Booking Pune"],
    ["Local & Outstation Cabs Online Pune", ""],
   
],





       "whychoose": [
    {
        "WhyChooseheading": "Convenient Online Cab Booking in Pune",
        "WhyChoosedescription": "Meghana Cab offers an easy and efficient way to book cabs online in Pune. Our user-friendly website and mobile app make it simple to reserve a ride anytime, from anywhere, ensuring a smooth booking experience for all your travel needs."
    },
    {
        "WhyChooseheading": "Reliable and Punctual Service",
        "WhyChoosedescription": "We value your time. Meghana Cab ensures timely pick-up and drop-off services across Pune. Whether you're heading to the airport, attending a meeting, or going sightseeing, you can count on us to be on time, every time."
    },
    {
        "WhyChooseheading": "Experienced and Courteous Drivers",
        "WhyChoosedescription": "Our professional drivers are well-trained and familiar with Pune’s roads and traffic conditions. They focus on delivering a safe, smooth, and comfortable ride, ensuring your journey with Meghana Cab is pleasant from start to finish."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "With Meghana Cab, you get fair and transparent pricing with no hidden charges. Our online cab booking system gives upfront fare estimates, helping you plan your travel budget confidently and without surprises."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability in Pune",
        "WhyChoosedescription": "Need a cab early in the morning or late at night? Meghana Cab operates round the clock, providing you with reliable cab services in Pune whenever you need them—day or night."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Rides",
        "WhyChoosedescription": "Your safety is our top priority. All Meghana Cab vehicles are regularly maintained and equipped with essential safety features like GPS tracking, sanitized interiors, and seat belts for a secure and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Multiple Cab Options to Suit Your Needs",
        "WhyChoosedescription": "From compact cars for solo rides to larger vehicles for families or groups, Meghana Cab offers a wide range of cab options for online booking in Pune. Choose the vehicle that best fits your travel requirements."
    },
    {
        "WhyChooseheading": "Simple and Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a cab with Meghana Cab is fast and hassle-free. Whether you prefer using our mobile app, website, or calling our customer service, we make the booking process easy so you can focus on your journey."
    }
]














    }

   const faqData = [
    {
        question: "How can I book a cab online with Meghana Cab in Pune?",
        answer: "You can easily book a cab online through the Meghana Cab website or by calling our customer support. The process is quick, simple, and convenient."
    },
    {
        question: "What types of cabs are available for online booking in Pune?",
        answer: "Meghana Cab offers a variety of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to meet different travel needs."
    },
    {
        question: "Are the online cab fares fixed or do they vary?",
        answer: "Fares may vary depending on the type of vehicle, distance, and time of booking. We ensure transparent pricing with no hidden charges."
    },
    {
        question: "Can I schedule a ride in advance with Meghana Cab?",
        answer: "Yes, you can schedule your ride in advance by selecting your preferred date and time during the online booking process."
    },
    {
        question: "Do Meghana Cab drivers have proper identification and training?",
        answer: "Yes, all our drivers are professionally trained, verified, and experienced to ensure your safety and comfort."
    },
    {
        question: "What is your cancellation policy for online cab bookings?",
        answer: "We offer a flexible cancellation policy. Please refer to the booking details or contact our support team for more information."
    },
    {
        question: "Which payment methods are accepted for online cab bookings?",
        answer: "We accept multiple payment options including UPI, credit/debit cards, net banking, and mobile wallets for your convenience."
    },
    {
        question: "Is there an option for one-way and round-trip bookings?",
        answer: "Yes, Meghana Cab provides both one-way and round-trip booking options to cater to different travel plans."
    },
    {
        question: "Can I request special amenities like a child seat?",
        answer: "Yes, amenities like child seats can be arranged on request during the booking process. Please mention your requirements in advance."
    },
    {
        question: "How can I contact Meghana Cab for booking or inquiries?",
        answer: "You can reach Meghana Cab at: +91 9075462128 for bookings and customer support."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Ankit Deshmukh',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booking a cab online with Meghana Cab was extremely smooth. The driver was punctual, the car was clean, and the whole experience was stress-free. Highly recommended for city travel in Pune.”',
    },
    {
        name: 'Ms. Priya Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I had a great experience booking a cab with Meghana Cab. Their online booking platform is user-friendly, and the service was excellent. I’ll definitely use them again for my travels in Pune.”',
    },
];









































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const cabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.meghanacabs.com/online-cab-booking-pune#service",
  "serviceType": "Online Cab Booking in Pune",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com/"
  },
  "areaServed": ["Pune","Pimpri-Chinchwad","Pune Airport","Maharashtra","India"],
  "description": "Book a cab online in Pune with Meghana Cabs. 24x7 local rides, Pune Airport transfers, and outstation trips with professional drivers and clean AC cabs.",
  "offers": {
    "@type": "AggregateOffer",
    "priceCurrency": "INR",
    "lowPrice": "999",
    "highPrice": "8999",
    "offerCount": "12",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/online-cab-booking-pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": 5213
  }
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://www.meghanacabs.com/#biz",
  "name": "Meghana Cabs",
  "url": "https://www.meghanacabs.com/",
  "image": "https://www.meghanacabs.com/assets/images/online-cab-booking-pune.jpg",
  "priceRange": "₹₹",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Pune",
    "addressRegion": "MH",
    "addressCountry": "IN"
  },
  "areaServed": ["Pune","Pimpri-Chinchwad","Pune Airport","Mumbai","Nashik","Satara","Kolhapur"],
  "openingHoursSpecification": [{
    "@type": "OpeningHoursSpecification",
    "dayOfWeek": [ "Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday" ],
    "opens": "00:00",
    "closes": "23:59"
  }],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": 6123
  }
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://www.meghanacabs.com/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Online Cab Booking in Pune",
      "item": "https://www.meghanacabs.com/online-cab-booking-pune"
    }
  ]
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "How do I book a cab online in Pune?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Select pickup and drop, choose your cab type, confirm fare, and complete booking. You’ll get instant driver details on confirmation."
      }
    },
    {
      "@type": "Question",
      "name": "What are the starting fares for local and airport rides?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Local rides start at ₹999 for Sedan (limited kms/hours). Pune Airport pickup/drop has all-inclusive fixed fares visible before payment."
      }
    },
    {
      "@type": "Question",
      "name": "Do you provide outstation cab services from Pune?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes, one-way and round-trip outstation rides to Mumbai, Nashik, Satara, Kolhapur, and more, with well-maintained AC cars and verified drivers."
      }
    },
    {
      "@type": "Question",
      "name": "Which car types are available?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sedan, SUV, and premium cabs. All options are AC with professional drivers. Choose as per passengers, luggage, and budget."
      }
    }
  ]
};


    return (
        <div>

<Helmet>
  {/* Canonical SEO essentials */}
  <title>Online Cab Booking in Pune | 24x7 Airport, Local & Outstation | Meghana Cabs</title>
  <meta
    name="description"
    content="Online cab booking in Pune: 24x7 local rides, Pune Airport transfers, and outstation trips. Sedan & SUV AC cabs, transparent fares, professional drivers. Book now."
  />
  <link rel="canonical" href="https://www.meghanacabs.com/online-cab-booking-pune" />
  <meta name="robots" content="index,follow,max-snippet:-1,max-image-preview:large,max-video-preview:-1" />

  {/* (Optional) Keep if you want – search engines mostly ignore meta keywords */}
  <meta
    name="keywords"
    content="Online Cab Booking Pune, Pune Airport Cab, Local Taxi Pune, Outstation Cabs from Pune, Sedan Cab Pune, SUV Cab Pune, Book Taxi Pune Online"
  />

  {/* Open Graph / Twitter */}
  <meta property="og:type" content="website" />
  <meta property="og:title" content="Online Cab Booking in Pune | Meghana Cabs" />
  <meta
    property="og:description"
    content="24x7 local, airport, and outstation cabs in Pune. Clean AC cars, verified drivers, upfront pricing."
  />
  <meta property="og:url" content="https://www.meghanacabs.com/online-cab-booking-pune" />
  <meta property="og:image" content="https://www.meghanacabs.com/assets/images/online-cab-booking-pune.jpg" />

  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Online Cab Booking in Pune | Meghana Cabs" />
  <meta
    name="twitter:description"
    content="Book cabs in Pune—local, airport, and outstation. Transparent fares and 24x7 support."
  />
  <meta name="twitter:image" content="https://www.meghanacabs.com/assets/images/online-cab-booking-pune.jpg" />

  {/* JSON-LD (as separate scripts or one @graph; either is fine) */}
  <script type="application/ld+json">{JSON.stringify(cabServiceSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
  <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
</Helmet>






            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/1.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Onlinecabbookinginpune;